import { DropZone, FileTrigger } from 'react-aria-components'
import { GridList, GridListItem } from '~/ui/GridList'
import { Label } from '~/ui/Field'
import { Button } from '~/ui/Button'
import { useFeedbackDialogContext } from '~/components/ErrorBoundary/context'
import { Icon } from '~/ui/Icon'

const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/avif', 'image/webp']
const VIDEO_TYPES = ['video/mp4', 'video/mpeg', 'video/ogg', 'video/webm', 'video/quicktime']
const MEDIA_TYPES = [...IMAGE_TYPES, ...VIDEO_TYPES]

export const FileDragAndDrop = () => {
  const { files, deleteFile, addFiles } = useFeedbackDialogContext()
  const isEmptyFileList = files.length === 0
  return (
    <div className="space-y-1">
      <Label>Please add an image or video showing the issue</Label>
      <DropZone
        className={({ isDropTarget }) => `p-3 border ${isDropTarget ? 'border-dashed bg-gray-100 cursor-copy' : ''}`}
        onDrop={async e => {
          const files = e.items.filter(files => files.kind === 'file')
          const data = await Promise.all(files.map(async file => await file.getFile()))
          addFiles(data)
        }}
      >
        <GridList items={files} aria-label="Selected files" className={isEmptyFileList ? 'border-none' : ''}>
          {({ file, id }) => (
            <GridListItem id={id} key={id} textValue={file.name}>
              <div className="w-full flex flex-row justify-between">
                <div className="flex flex-row items-center gap-1">
                  {file.type.startsWith('image') ? (
                    <Icon name="fileImage" size={24} />
                  ) : (
                    <Icon name="fileVideo" size={24} />
                  )}
                  <span className="align-middle">{file.name}</span>
                </div>
                <Button aria-label="Remove" variant="icon" onPress={() => deleteFile(id)}>
                  <Icon name="cross" />
                </Button>
              </div>
            </GridListItem>
          )}
        </GridList>
        <FileTrigger
          acceptedFileTypes={MEDIA_TYPES}
          onSelect={list => {
            if (list === null) return
            addFiles(Array.from(list))
          }}
        >
          <div className={`flex flex-row gap-1 justify-center items-center ${isEmptyFileList ? '' : 'pt-3'}`}>
            <Button variant="small">{isEmptyFileList ? 'Choose files' : 'Choose more files'}</Button>
            or drag & drop them here
          </div>
        </FileTrigger>
      </DropZone>
    </div>
  )
}
